import m from 'mithril'

export default m.trust(`
	<svg width="20" height="20" viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_689_58092)">
            <path d="M14.7696 -27.8907H-27.1213V14.0002H0.249579C8.26876 14.0002 14.7696 7.49933 14.7696 -0.519844V-27.8907Z" fill="white"/>
            <path d="M18.7696 -27.8907H60.6605V14.0002H18.7696V-27.8907Z" fill="white"/>
            <path d="M14.7696 59.891H-27.1213V18.0001H14.7696V59.891Z" fill="white"/>
            <path d="M18.7696 59.891H60.6605V18.0001H33.2896C25.2704 18.0001 18.7696 24.5009 18.7696 32.5201V59.891Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_689_58092">
                <rect width="32" height="32" fill="white" transform="translate(0.769592)"/>
            </clipPath>
        </defs>
	</svg>
`)